// Libraries
import React from 'react'
import styled, { css } from 'styled-components'

// Styles
import { TextOutlined as STextOutline} from '../../../layouts/MainWrapperWithCaptions/style'

export const TextOutlinedL = styled(STextOutline)`
  font-weight: 600;
  font-size: 140px;
  line-height: 191px;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      font-size: 80px;
      line-height: 109px;
    }
  `}
`;
